import moment from 'moment';
import React from 'react';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import { dateToStringWithDailyTimeZone } from '@/shared/lib';
import { getTimeString } from '@/shared/lib/aiUtils';

export type LoadingMigrateProps = {
  percentage: number;
  estimateTime: number;
  study: {
    start?: moment.MomentInput;
    timezone?: string;
    facility?: any;
  };
  migratingAt?: string;
  isUpdateMirage?: boolean;
};

const LoadingMigrate = ({
  percentage,
  estimateTime,
  study,
  migratingAt,
  isUpdateMirage,
}: LoadingMigrateProps) => (
  <div className="loading-migrate-container">
    <div className="progress-container">
      <CircularProgressbar
        value={percentage}
        text={`${percentage}%`}
        styles={buildStyles({
          textSize: '22px',
          pathColor: '#0D9E92',
          textColor: '#1D2F47',
          trailColor: '#CCEDEF',
          strokeLinecap: 'butt',
          // `fontWeight` isn't a real buildStyles option — pre-existing no-op.
          ...({ fontWeight: 'bold' } as any),
        })}
      />
    </div>
    <div className="loading__text">
      <div>Updating study...</div>
      <div>
        {isUpdateMirage
          ? 'This study is currently being updated the data.\nPlease wait a moment.'
          : 'This study is currently being updated to the latest version of the system. Please wait a moment.'}
      </div>
      <div>{isUpdateMirage ? '' : `Estimated time left: ${getTimeString(estimateTime)}`}</div>
      {!isUpdateMirage && (
        <div>
          {`Start time: ${dateToStringWithDailyTimeZone({
            startStudyDate: study?.start,
            isoDate: migratingAt || moment().toISOString(),
            timezone: study.timezone,
            facility: study.facility,
          })}`}
        </div>
      )}
    </div>
  </div>
);

export default LoadingMigrate;
